/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Contact_TitleInputs */

const en_meta_contact_title = /** @type {(inputs: Meta_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening App: Contact us`)
};

const es_meta_contact_title = /** @type {(inputs: Meta_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening App: Contáctanos`)
};

/**
* | output |
* | --- |
* | "Listening App: Contact us" |
*
* @param {Meta_Contact_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const meta_contact_title = /** @type {((inputs?: Meta_Contact_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Contact_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_meta_contact_title(inputs)
	return en_meta_contact_title(inputs)
});